import { render } from "./MobileProfileButton.vue?vue&type=template&id=e0d133ae&scoped=true"
import script from "./MobileProfileButton.vue?vue&type=script&lang=js"
export * from "./MobileProfileButton.vue?vue&type=script&lang=js"

import "./MobileProfileButton.vue?vue&type=style&index=0&id=e0d133ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e0d133ae"
/* hot reload */
if (module.hot) {
  script.__hmrId = "e0d133ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0d133ae', script)) {
    api.reload('e0d133ae', script)
  }
  
  module.hot.accept("./MobileProfileButton.vue?vue&type=template&id=e0d133ae&scoped=true", () => {
    api.rerender('e0d133ae', render)
  })

}

script.__file = "src/ui/buttons/MobileProfileButton.vue"

export default script